import { useEffect, useState } from 'react';

import { prefersReducedMotion } from '../../hooks/usePrefersReducedMotion';

/** Types and deletes each phrase in turn. */
export default function Typewriter({ words, typeSpeed = 70, deleteSpeed = 35, pause = 1800 }) {
  const [index, setIndex] = useState(0);
  const [text, setText] = useState(() => (prefersReducedMotion() ? words[0] : ''));
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    if (prefersReducedMotion()) return undefined;
    const word = words[index % words.length];
    let delay = deleting ? deleteSpeed : typeSpeed;

    if (!deleting && text === word) delay = pause;
    else if (deleting && text === '') delay = 300;

    const id = setTimeout(() => {
      if (!deleting && text === word) {
        setDeleting(true);
      } else if (deleting && text === '') {
        setDeleting(false);
        setIndex((i) => i + 1);
      } else {
        setText(deleting ? word.slice(0, text.length - 1) : word.slice(0, text.length + 1));
      }
    }, delay);
    return () => clearTimeout(id);
  }, [text, deleting, index, words, typeSpeed, deleteSpeed, pause]);

  return (
    <span className="typewriter">
      <span className="sr-only">{words.join(', ')}</span>
      <span aria-hidden="true">{text}</span>
      <span className="typewriter__caret" aria-hidden="true" />
    </span>
  );
}
